module.exports = __webpack_public_path__ + "static/media/lullascape-4.52a18cbc.jpg";